import LineIcon from "@assets/icons/line.svg";
import { Button } from "@miror-ui/components";
import { signIn } from "next-auth/client";
import { FC, useState } from "react";
import { useHostName } from "shared/hooks/useHostName";
import { Paths } from "utils/routes";

interface Props {
  className?: string;
  callbackUrl?: string;
}

export const LineAuthButton: FC<Props> = ({
  children,
  className,
  callbackUrl,
}) => {
  const [disabled, setDisabled] = useState(false);

  const { host } = useHostName();

  const handleLogin = () => {
    setDisabled(true);
    signIn("line", {
      callbackUrl:
        callbackUrl || `${host}${Paths.callbacks["line"].default().pathname}`,
    });
  };

  return (
    <Button
      tw="from-line to-line h-16"
      onClick={handleLogin}
      disabled={disabled}
      data-cy="line-login-btn"
      className={className}
    >
      <LineIcon tw="w-7 h-7 mr-2 svg text-white" />
      {children}
    </Button>
  );
};
